<input type="text"
       [placeholder]="_placeholder"
       matInput
       #input
       [disabled]="disabled"
       [required]="true"
       [value]="value?.country"
       (input)="onInputChange($event)"
       (focus)="onFocusIn($event)"
       (blur)="onFocusOut($event)"
       [matAutocomplete]="auto">
       
<mat-autocomplete 
    #auto="matAutocomplete" 
    [displayWith]="displayFn"
    requireSelection
    (optionSelected)="onAutocompleteSelection($event)">
    
  @for (country of filteredOptions; track country) {
    <mat-option [value]="country">{{country.country}}</mat-option>
  }
</mat-autocomplete>